import { useAuth0 } from '@auth0/auth0-react'
import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useState } from 'react'

import { SignIn } from '@/components/screens/sign-in'
import { AUTH_REFRESH_FAILURE_NOTICE_KEY } from '@/lib/auth-refresh-notice'

function Page() {
  const { isAuthenticated, loginWithRedirect } = useAuth0()
  const [notice, setNotice] = useState<string | null>(() => sessionStorage.getItem(AUTH_REFRESH_FAILURE_NOTICE_KEY))

  if (isAuthenticated) {
    return <Navigate to="/" />
  }

  return (
    <SignIn
      notice={notice}
      onDismissNotice={() => {
        sessionStorage.removeItem(AUTH_REFRESH_FAILURE_NOTICE_KEY)
        setNotice(null)
      }}
      onLogin={() => {
        sessionStorage.removeItem(AUTH_REFRESH_FAILURE_NOTICE_KEY)
        void loginWithRedirect()
      }}
    />
  )
}

export const Route = createFileRoute('/sign_in')({
  component: Page,
})
